<script setup lang="ts">
defineProps({
  placeholder: null
})
defineEmits(["submit"])
const date = defineModel<number>()
</script>

<template>
  <div class="dropdown-number-input">
    <interface-input
      :model-value="(new Date(date ?? 0)).toISOString().substring(0, 16)"
      type="datetime-local"
      :placeholder
      transparent
      no-ring
      @update:model-value="(value?: string) => { date = (new Date(value ?? 0)).getTime() }"
      @keydown.enter="(e: KeyboardEvent) => $emit('submit', e)"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.dropdown-number-input
  @apply font-mono
</style>
